import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { RouteLocations } from '../../common/routing/route-locations.enum';
import { LogoComponent } from '../../common/components/logo/logo.component';
import { Environment } from '../../../environments/environment.interface';
import { ENVIRONMENT } from '../../common/services/injection-tokens';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faDiscord, faPatreon } from '@fortawesome/free-brands-svg-icons';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterLink, LogoComponent, FaIconComponent],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  constructor(@Inject(ENVIRONMENT) private _environment: Environment) {}

  protected readonly homeQueryParams = {
    [RouteLocations.Home.queryParams.Stay]: '1',
  };

  protected readonly year = new Date().getFullYear();

  protected readonly patreonLink = this._environment.links.patreonUrl;
  protected readonly discordLink = this._environment.links.discordUrl;

  protected readonly RouteLocations = RouteLocations;
  protected readonly faDiscord = faDiscord;
  protected readonly faPatreon = faPatreon;
}
